module.exports = __webpack_public_path__ + "static/logo-8d304d418dc97ebc20314f19f2e52c0b.png";